export const environment = {
  TURBINE_ENV: 'TURBINE_ENV_REPLACEMENT',
  ONLY_CONTROL: 'ONLY_CONTROL_REPLACEMENT'
};
